import React, { useEffect, useState } from 'react'
import TableGeneric from '../../../compartidos/abms/TableGeneric'
import { Grid, Typography,MenuItem, Divider, Button, Dialog, DialogTitle } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Buscador from '../../../../actions/ui/Buscador';
import { Autorenew } from '@material-ui/icons';
import { changeStepper } from '../../../../actions/preAfiliado/stepper';
import { startAlerta } from '../../../../actions/ui/alertas';
import { sendValuesAfiliacionWeb } from '../../../../actions/preAfiliado/afiliadoWeb';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  hideButton: {
    display: "none",
  },
}));

const mensaje1 = "¿A quienes te gustaría incluir en la obra social? (Especifica)"
const mensaje2 = "El grupo familiar puede incluir pareja (acta convivencia/certificado de matrimonio) e hijas/os menores de 21 años o hasta 25 años con Certificado de Alumno Regular"
const mensaje3 = "¿Qué cobertura médica tenés hoy en día? (Por ejemplo: Opoce, Osecac, Swiss Medical, Galeno, Hospital Italiano, Hospital Alemán, Sancor Salud, etc.)"

const origenesFormulario = [{
  id: 1,
  descripcion: "facebook"
},
{
  id: 2,
  descripcion: "recomendacion"
},
{
  id: 3,
  descripcion: "otro"
}
]

export const GrupoFamiliarPreAfiliadoWeb = ({ form, afiliado }) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const { step } = useSelector((state) => state.stepper);
  const { items } = useSelector((state) => state.localidades);
  const { items: provincias } = useSelector(state => state.provincias);

  const [modalConfirmacion, setModalConfirmacion] = useState(false)
  const [rnos, setRnos] = useState(null)
  const [buscadorRnos, setBuscadorRnos] = useState(true)
  const handleChangeBuscador = () => {
    if (buscadorRnos) {
      setBuscadorRnos(false)
      setRnos(null)
      form.setearValor("rnos", "")
    } else {
      setBuscadorRnos(true)
      form.setearValor("cobertura", "")
    }
  }

  const handleSubmit = () => {
    if (buscadorRnos && rnos === null) {
      dispatch(startAlerta("Debe seleccionar una cobertura", "error", "Error"))
    } else {
      setModalConfirmacion(true)
    }
  }

  useEffect(() => { if (form.formValues.origen !== 3) form.setearValor("observacion_Origen", "") }, [form.formValues.origen])

  return (
    <>
      <ValidatorForm onSubmit={handleSubmit}>
        <div className={classes.root}>
          <Grid
            container
            spacing={1}
            justify="center"
          >
            <Grid item xs={12}>
              <TableGeneric
                data={afiliado ? [afiliado] : []}
                columns={[
                  {
                    label: "Nro Documento",
                    id: "nro_doc"
                  },
                  {
                    label: "Apellido y Nombre",
                    id: "apellido_y_nombre"
                  },
                  {
                    label: "Parentesco",
                    customBody: () => "TITULAR"
                  },
                  {
                    label: "Fecha Nacimiento",
                    customBody: (item) => moment(item.fecha_nacimiento).format("DD/MM/YYYY")
                  },
                  {
                    label: "Localidad",
                    customBody: (item) => items.find((loc) => parseInt(loc?.id_localidad) === parseInt(item.domiciliosAfiliados?.id_localidad)).descripcion_localidad
                  },
                  {
                    label: "Provincia",
                    customBody: (item) => provincias.find((prov) => parseInt(prov.id_provincia) === parseInt(item.domiciliosAfiliados?.id_provincia)).descripcion_provincia
                  }
                ]}
                align={"center"}
                withoutPagination
              />
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Typography>{mensaje1}</Typography>
            </Grid>
            <Grid item xs={7} >
              <Typography>{mensaje2}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Grid container justify="space-between">
                <Grid item xs={5}>
                  <TextValidator
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Familiares a incluir en el grupo (0 es ninguno)"
                    name="familia"
                    disabled={false}
                    value={form?.formValues?.familia || ""}
                    autoComplete="off"
                    inputProps={{ maxLength: 1 }}
                    validators={["required", "isNumber"]}
                    errorMessages={["Requerido", "Solo número"]}
                    onChange={(e) => form?.setearValor("familia", e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Divider />
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Typography>{mensaje3}</Typography>
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Grid container display="flex" justify="space-between" alignItems='center'>
                <Grid item xs={7}>
                  {
                    buscadorRnos ? (
                      <Buscador
                        variant="outlined"
                        value={rnos}
                        setValue={(rnos) => {
                          if (rnos !== null) {
                            setRnos(rnos)
                            form.setearValor("rnos", rnos.rnosclean)
                          } else {
                            setRnos(null)
                            form.setearValor("rnos", "")
                          }
                        }}
                        label="Cobertura Anterior"
                        endpoint={(texto) => `RNOS/bySP/${texto}`}
                        noOptionText={"No se encontró cobertura"}
                        getOptionLabel={(option) => (`${option.denominacion}`)}
                        renderOption={(option) => (
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span >
                              {`${option.denominacion}`}
                            </span>
                          </div>
                        )}
                      />
                    ) : (
                      <TextValidator
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Cobertura Anterior"
                        name="cobertura"
                        value={form.formValues.cobertura}
                        autoComplete="off"
                        validators={["required"]}
                        errorMessages={["Este campo es obligatorio"]}
                        onChange={(e) => form.setearValor("cobertura", e.target.value)}
                      />
                    )
                  }
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={handleChangeBuscador}
                    startIcon={<Autorenew />}
                  >
                    {
                      buscadorRnos ? "Cambiar a manual" : "Cambiar a Buscador"
                    }
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Divider />
            </Grid>
            <Grid item xs={7} style={{ padding: 10 }}>
              <Typography>¿Cómo llegaste a este formulario?</Typography>
            </Grid>
            <Grid item xs={7}>
              <Grid container display="flex" justify="flex-start" alignItems='center'>
                <Grid item xs={5}>
                  <SelectValidator
                    variant="outlined"
                    value={form.formValues.origen}
                    onChange={(e) => {
                      form.setearValor("origen", e.target.value)
                    }}
                    label="Referencia"
                    name="origen"
                    validators={["required"]}
                    errorMessages={["Este campo es obligatorio"]}
                    fullWidth={true}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      shrink: true,
                    }}
                  >
                    {
                      origenesFormulario.map((option, index) => (
                        <MenuItem
                          key={index} value={option.id}>{option.descripcion}</MenuItem>
                      ))
                    }
                  </SelectValidator>
                </Grid>
                <Grid item xs={5} style={{ marginLeft: "3em" }}>
                  {
                    form.formValues.origen === 3 && (
                      <TextValidator
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Origen"
                        name="observacion_Origen"
                        value={form.formValues.observacion_Origen}
                        autoComplete="off"
                        validators={["required"]}
                        errorMessages={["Este campo es obligatorio"]}
                        onChange={(e) => form.setearValor("observacion_Origen", e.target.value)}
                      />)
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Button id="btnsubmitGrupoFamiliar" className={classes.hideButton} type="submit">
            Submit
          </Button>
        </div>
      </ValidatorForm>
      {
        modalConfirmacion &&
        <Dialog
          fullWidth={true}
          open={modalConfirmacion}
          onClose={() => { setModalConfirmacion(false) }}
        >
          <DialogTitle style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="button" style={{ fontSize: "1em" }}>
              REVISE SUS DATOS
            </Typography>
          </DialogTitle>
          <Divider />
          <Grid container>
            <Grid item xs={12} style={{ margin: "1em" }}>
              <Typography>
                ¿Desea confirmar el Envío?
                Recuerde que no es posible retroceder
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", margin: "1em" }}>
              <Button
                variant='contained'
                color='secondary'
                onClick={() => { setModalConfirmacion(false) }}
              >
                CANCELAR
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={() => { 
                  setModalConfirmacion(false)
                  dispatch(sendValuesAfiliacionWeb(
                    form.formValues, 
                    (idAfiliado) => {
                      dispatch(changeStepper(step + 1))
                      form.setearValor("idAfiliado", idAfiliado)
                    }
                  ))
                }}
              >
                ENVIAR
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      }
    </>
  )
}
